import { render, staticRenderFns } from "./MarketPlaceView.vue?vue&type=template&id=4087d720&scoped=true"
import script from "./MarketPlaceView.vue?vue&type=script&lang=js"
export * from "./MarketPlaceView.vue?vue&type=script&lang=js"
import style0 from "./MarketPlaceView.vue?vue&type=style&index=0&id=4087d720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087d720",
  null
  
)

export default component.exports